import React from 'react';
import { useAuth } from '../Context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

// El 'children' es el componente que queremos proteger (ej. Dashboard)
function ProtectedRoute({ children }) {
  const { session, loading } = useAuth();

  // Si aún está cargando la sesión, no mostramos nada
  if (loading) {
    return <div>Cargando...</div>; // O un Spinner
  }

  // Si no hay sesión (no está logueado), redirigimos a /login
  if (!session) {
    return <Navigate to="/login" replace />; // 'replace' evita que pueda volver atrás
  }

  // Si hay sesión, mostramos el componente hijo (Dashboard)
  // 'children' es una prop. Si usas <Outlet> (para rutas anidadas), es mejor.
  // Usaremos 'children' por simplicidad.
  return children; 
}

export default ProtectedRoute;